import { Plugin } from "prosemirror-state";
import { ReactPluginView } from "../../react/react-plugin-view";
/**
 * Creates a new prosemirror plugin that renders a react suggester component.
 *
 * @param suggesterCallbacksRegistry The registry that holds the suggester callbacks.
 * @param SuggesterComponent The react component to be rendered. It must accept the props defined by `SuggesterComponentProps`.
 * @param extraProps Any extra props you want to pass to the react component.
 *
 * @returns A new prosemirror plugin.
 */
export function suggestPlugin(portalContainer, suggesterCallbacksRegistry, SuggesterComponent, extraProps) {
    return new Plugin({
        view: ReactPluginView.create({
            portalContainer,
            component: SuggesterComponent,
            extraProps: {
                suggesterCallbacksRegistry,
                ...extraProps,
            },
        }),
    });
}
/**
 * A registry for all `prosemirror-suggest` callbacks.
 */
export class SuggesterCallbacksRegistry {
    constructor() {
        this.outsideCallbacks = {};
    }
    register(callbacks) {
        this.outsideCallbacks = callbacks;
        return () => {
            this.outsideCallbacks = {};
        };
    }
    get callbacks() {
        return {
            onChange: (params) => { var _a, _b; return (_b = (_a = this.outsideCallbacks).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, params); },
            onExit: (params) => { var _a, _b; return (_b = (_a = this.outsideCallbacks).onExit) === null || _b === void 0 ? void 0 : _b.call(_a, params); },
            keyBindings: {
                ArrowDown: (params) => { var _a, _b; return (_b = (_a = this.outsideCallbacks).ArrowDown) === null || _b === void 0 ? void 0 : _b.call(_a, params); },
                ArrowUp: (params) => { var _a, _b; return (_b = (_a = this.outsideCallbacks).ArrowUp) === null || _b === void 0 ? void 0 : _b.call(_a, params); },
                ArrowLeft: (params) => { var _a, _b; return (_b = (_a = this.outsideCallbacks).ArrowLeft) === null || _b === void 0 ? void 0 : _b.call(_a, params); },
                ArrowRight: (params) => { var _a, _b; return (_b = (_a = this.outsideCallbacks).ArrowRight) === null || _b === void 0 ? void 0 : _b.call(_a, params); },
                Enter: (params) => { var _a, _b; return (_b = (_a = this.outsideCallbacks).Enter) === null || _b === void 0 ? void 0 : _b.call(_a, params); },
                Escape: (params) => { var _a, _b; return (_b = (_a = this.outsideCallbacks).Escape) === null || _b === void 0 ? void 0 : _b.call(_a, params); },
                Backspace: (params) => { var _a, _b; return (_b = (_a = this.outsideCallbacks).Backspace) === null || _b === void 0 ? void 0 : _b.call(_a, params); },
                Delete: (params) => { var _a, _b; return (_b = (_a = this.outsideCallbacks).Delete) === null || _b === void 0 ? void 0 : _b.call(_a, params); },
            },
        };
    }
}
